'use client'

/* ---------------------------------
Slider
--------------------------------- */

import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y, Navigation, Pagination, Scrollbar } from 'swiper/modules'
import { SliderNavigation } from './SliderNavigation'

export default function Slider({
  slides,
  children,
  className,
  slidesPerView = 1,
  ...sliderProps
}: {
  slides: JSX.Element[]
  children?: React.ReactNode
  className?: string
  slidesPerView?: number | 'auto'
  [key: string]: any
}) {
  return (
    <div className={`Slider ${className ? className : ''}`}>
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        spaceBetween={50}
        slidesPerView={slidesPerView}
        navigation={{
          nextEl: '.Slider__controls__navigation__button--next',
          prevEl: '.Slider__controls__navigation__button--prev',
        }}
        pagination={{
          clickable: true,
          el: '.Slider__controls__pagination',
          bulletClass: 'Slider__controls__pagination__step',
          bulletActiveClass: 'Slider__controls__pagination__step--active',
        }}
        {...sliderProps}
      >
        {slides?.map?.((slide, i) => (
          <SwiperSlide key={`Slider__slide__${i}`}>{slide}</SwiperSlide>
        ))}

        {children ? <div className={'Slider__children'}>{children}</div> : null}

        <div className='Slider__controls'>
          {/*
            Swiper will generate the nodes for us;
            the classes are targeted in src/styles/components/_slider.scss:22
          */}
          <div className='Slider__controls__pagination' />

          <SliderNavigation />
        </div>
      </Swiper>
    </div>
  )
}
